import { render } from "./verify-pass.vue?vue&type=template&id=2342bbc6"
import script from "./verify-pass.vue?vue&type=script&lang=js"
export * from "./verify-pass.vue?vue&type=script&lang=js"

import "./verify-pass.vue?vue&type=style&index=0&id=2342bbc6&lang=scss"

import exportComponent from "/__w/dryrobe.com-website/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__